module.exports = __webpack_public_path__ + "img/bg-saldo.9a3feee7.svg";